class NumberInput {
	constructor(config) {
		this.config = Object.assign({
			scope: '.input-group',
			minusBtn: '.btn-minus',
			plusBtn: '.btn-plus'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click', this.config.minusBtn, this.changeAmount.bind(this));
		this.$scope.on('click', this.config.plusBtn, this.changeAmount.bind(this));
	}

	changeAmount(e) {
		e.preventDefault();
		const isNegative = $(e.currentTarget).closest('.btn-minus').is('.btn-minus');
		const input = $(e.currentTarget).closest('.input-group').find('input');
		if (input.is('input')) {
			input[0][isNegative ? 'stepDown' : 'stepUp']();
			input.trigger('change');
		}
	}
}

export default NumberInput;